import { ContactsCSVType } from '../controllers/ContactsCotroller';
import { Pagination } from '../store-interfaces';

export enum CaptureActionEnum {
  'do_not_capture' = 'do_not_capture',
  'do_not_send' = 'do_not_send',
}

export interface SuppressionSettingsModel {
  id: number;
  list: (string | number)[];
  listToDelete?: (string | number)[];
  captureAction: CaptureActionEnum;
  data?: { sendSignal: boolean };
}

export type SuppressionSettingsCSVModel = Partial<ContactsCSVType> & {
  kind?: 'google_sheet' | 'csv_file';
  refreshedAt?: Date;
  processed?: boolean;
};

export type SuppressionSettingsCSVResponse = {
  csvs: SuppressionSettingsCSVModel[];
  pagination: Pagination;
};
